import { FormImageElement } from "@redotech/redo-model/signup-form";
import ImageIcon from "@redotech/redo-web/arbiter-icon/image-01.svg";
import { memo } from "react";
import { Flex } from "../../flex";
import * as ImageCSS from "./form-image.module.css";
import { FormElementProps } from "./index";

export const FormImage = memo(function FormImage({
  element,
}: FormElementProps<FormImageElement>) {
  return (
    <Flex w="full">
      {element.url !== "" ? (
        <img src={element.url} />
      ) : (
        <div className={ImageCSS.placeholder}>
          <ImageIcon />
          Add image
        </div>
      )}
    </Flex>
  );
});
